/**
 * Shared constants for A2F-587 commons-access enforcement.
 *
 * The AuthContext writes a flash into sessionStorage when the commons
 * access check denies a user (A2F-633 architectural fix: flash only,
 * no signOut — Supabase session is preserved so transient onboarding
 * flows can complete their downstream work). LoginPage reads + clears
 * it on mount. Defining the key in one place avoids silent drift if
 * either side is edited.
 */

export const COMMONS_AUTH_ERROR_KEY = 'commons_auth_error'

export const COMMONS_AUTH_ERROR_MESSAGE =
  'This account does not have CTDCommons access. ' +
  'Please sign up with a different email or contact support.'
